/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

// import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Subject } from 'rxjs';

import * as strings from '@touchplan/strings';

import { SimplePopupInputs, PopupCommunication, PopupOutput, PopupOutputType } from './interfaces';

export class PopupBaseComponent implements PopupCommunication {
	protected _output$ = new Subject<PopupOutput>();
	public output$ = this._output$.asObservable();
	public popupText: SimplePopupInputs = {
		headingText: strings.DEFAULT_POPUP_HEADING,
		descriptionText: null,
		customSaveText: strings.DEFAULT_POPUP_SAVE_BUTTON,
		customCancelText: strings.DEFAULT_POPUP_CANCEL_BUTTON,
	};

	public popupInit(data: any = {}) {
		['headingText', 'descriptionText', 'customSaveText', 'customCancelText'].forEach((key) => {
			if (data[key] !== undefined) {
				this.popupText[key] = data[key];
			}
		});
	}

	/**
	 * push output, wraps with the update type
	 * @param  data the output data
	 * @return      [description]
	 */
	public writeOutput(data?) {
		this._output$.next({
			type: PopupOutputType.update,
			data,
		});
	}
	/**
	 * push cancel the popup
	 * @param  data the output data
	 * @return      [description]
	 */
	public writeCancel(data?) {
		this._output$.next({
			type: PopupOutputType.canceled,
			data,
		});
	}
	public complete() {
		this._output$.complete();
	}
}
